import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Col, Modal, Row} from "react-bootstrap";

import {resetEntity, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {deleteUser, loadUser, saveUser} from '../actions/users';
import {defaultState} from '../reducers/entity';
import UserForm from '../components/user/UserForm';
import {Acl, breadcrumbs, Grid} from "./../utils";

class UserEditPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleSaveUser = this.handleSaveUser.bind(this);
		this.handleDeleteUser = this.handleDeleteUser.bind(this);
		this.handleOpenDeleteClick = this.handleOpenDeleteClick.bind(this);
		this.handleDismissDeleteClick = this.handleDismissDeleteClick.bind(this);

		this.state = {
			isDeleteModalOpen: false,
			deleteUser: null
		}
	}

	componentDidMount() {
		const {userId} = this.props.match.params;
		this.props.loadUser(userId || 'new')
	}

	componentDidUpdate(prevProps) {
		if ((prevProps.match.params.userId || 'new') !== (this.props.match.params.userId || 'new')) {
			this.props.loadUser(this.props.match.params.userId || 'new', true)
		}
	}

	componentWillUnmount() {
		this.props.resetEntity()
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleSaveUser(user) {
		return this.props.saveUser(user).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const personalId = json.response.data;
				return new Promise((resolve, reject) => resolve(this.props.history.push('/users/' + personalId)))
			} else {
				return new Promise((resolve, reject) => resolve())
			}
		})
	}

	handleOpenDeleteClick(user) {
		this.setState({isDeleteModalOpen: true, deleteUser: user})
	}

	handleDismissDeleteClick(e) {
		if (e) {
			e.preventDefault()
		}
		this.setState({isDeleteModalOpen: false, deleteUser: null})
	}

	handleDeleteUser(user) {
		return this.props.deleteUser(user.userId).then((json) => {
			this.handleDismissDeleteClick();
			if (json && json.response && json.response.result === 'OK') {
				return new Promise((resolve, reject) => resolve(this.props.history.push('/kluby')))
			}
		})
	}

	renderDeleteModal() {
		const {isDeleteModalOpen, deleteUser} = this.state;

		if (!isDeleteModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleDismissClick} show={true}>
				<Modal.Header>
					<Modal.Title>Trvalé smazání člena</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>Skutečně trvale odstranit člena <strong>{deleteUser.personalId}</strong>? Takto akce je nevratná.</p>
				</Modal.Body>

				<Modal.Footer>
					<Row>
						<Col sm={12}>
							<Button onClick={this.handleDismissDeleteClick}>Storno</Button>
							<Button type="submit" onClick={() => this.handleDeleteUser(deleteUser)} variant="danger">
								<span className="fa fa-trash"/> Trvale smazat člena</Button>
						</Col>
					</Row>
				</Modal.Footer>

			</Modal>
		)
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;

		if (entity.isFetchingItem || entity.item === null) {
			return Grid.renderIsFetchingData()
		}

		if ((!entity.id && !Acl.isAllowed(session, Acl.right.USER_NEW))
			|| (entity.id && !Acl.hasAction(entity.item, Acl.user.EDIT))) {
			return Grid.renderIsDenied()
		}

		const initialValues = entity.item;
		const bc = [
			{url: '/users', title: 'users'}
		];
		if (params.userId) {
			bc.push({url: '/users/' + params.userId, title: entity && entity.item && entity.item.personalId ? entity.item.lastName + ' ' + entity.item.firstName : '...', literal: true});
		} else {
			bc.push({url: '/users/new', title: 'user.new'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<UserForm {...entity} initialValues={initialValues}
					onSaveUser={this.handleSaveUser}
					onDeleteUser={this.handleOpenDeleteClick}
					onFetchEnums={this.handleFetchEnums} enums={enums} session={session}/>
				{this.renderDeleteModal()}
			</div>
		)
	}
}

UserEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadUser: PropTypes.func.isRequired,
	saveUser: PropTypes.func.isRequired,
	deleteUser: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {users},
		enums,
		session
	} = state;

	const entity = ownProps.match.params.userId
		? (users[ownProps.match.params.userId] || defaultState)
		: (users['new'] || Object.assign(defaultState, {item: {}}))

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadUser,
	saveUser,
	deleteUser,
	loadGeneralEnum,
	showMessage,
	resetEntity
})(UserEditPage)
